import { combineReducers } from 'redux'
import searchReducer from "./searchReducer.js";

import cartReducer from "./cartReducers.js";
import carsReducer from "./carsReducers.js";
import shopsReducer from "./shopsReducers.js";
import sharedReducer from "./sharedReducers.js";
import visitorReducer from "./visitorReducers.js";
import isProcessingReducer from "./processingReducers.js";

const rootReducer = combineReducers({
  cart: cartReducer,
  cars: carsReducer,
  shops: shopsReducer,
  shared: sharedReducer,
  visitor: visitorReducer,
  search: searchReducer,
  isProcessing: isProcessingReducer
})

export default rootReducer;